import YouTubePlayer from 'youtube-player';

export default function SectionSidekick(el, {
    actions,
    events,
    markup,
    youTubeVideoId,
}) {
    const modalBtns = el.querySelectorAll('.section-sidekick__modal-btn');

    modalBtns.forEach(modalBtn => {
        modalBtn.addEventListener('click', () => {
            events.emit(actions.loadModal, { markup });

            const player = document.getElementById('youtube-player');

            const youtubePlayer = YouTubePlayer(player, {
                videoId: youTubeVideoId,
                playerVars: {
                    autoplay: 1,
                },
            });

            events.on(actions.closeModal, () => youtubePlayer.pauseVideo());
        });
    });
}
